import React from "react";
import "react-toggle/style.css";
import QuoteStepBase from '../../components/QuoteStepBase';
import ButtonContinue from "../../components/ButtonContinue";
import { ValidatableForm } from "../../components/ValidatableForm";
import { IQuoteStepState, IDriverStepProps } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import Utilities from "../../classes/Utilities";
import { IQuoteApiClient, ILOBApiClient, IPaths, ViolationSource, IIncidentInfo } from "../../classes/Domain";
import * as _ from 'lodash';
import QuoteActions from "../../state/appActions";
import FullQuoteActions from "../../state/fullQuoteActions";
import moment from "moment";

interface IState extends IQuoteStepState {

}

interface IProps extends IDriverStepProps {
    quoteId: number,
    paymentPlanCode: number,
    violations: Array<IIncidentInfo> | null,
    driverViolationsGroupIndex: number,
    driversViolationsGroupCount: number,
    reRateQuote: (quoteId: number, paymentPlanCode: number) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

class Violations extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.initiated) {
            const nextState = {
                initiated : true
            };

            return nextState;
        }

        return prevState;
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    next() {
        var nextUrl = this.getNextUrl();

        this.setState({ updatingStore: true }, () => {
            if (this.props.driverViolationsGroupIndex === this.props.driversViolationsGroupCount - 1) {
                this.props.reRateQuote(this.props.quoteId, this.props.paymentPlanCode)
                    .then(() => {
                        this.setState({ ...this.state, updatingStore: false }, () => this.props.history.push(nextUrl));
                    });
            } else {
                this.setState({ ...this.state, updatingStore: false }, () => this.props.history.push(nextUrl));
            }
        });
    }

    getNextUrl() {
        return this.props.driverViolationsGroupIndex < this.props.driversViolationsGroupCount - 1
            ? Utilities.formatUrl(this.props.PATHS.FQ_VIOLATIONS, (this.props.driverViolationsGroupIndex + 1).toString())
            : this.props.PATHS.FQ_POLICY_DETAILS;
    }

    render() {
        return (
            <QuoteStep id="violations" className="">
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea">
                        <h5>Discovered Violations</h5>
                    </div>
                    <p className="info">The motor vehicle record for {this.props.driver?.firstName + " " + this.props.driver?.lastName} with the license number ending in {this.props.driver?.licenseNumber.substring(this.props.driver?.licenseNumber.length - 3)} was returned with the following violations/accidents:</p>
                    <div className="rate-result">
                        {
                            this.props.violations && this.props.violations.length > 0
                            ? 
                                <div className="payment-choice" key={Utilities.uniqueId()}>
                                    <div className="term">
                                        <div className="term-name">Violations</div>
                                    </div>
                                    {this.props.violations.map((violation, i) => (
                                        <div key={Utilities.uniqueId()} className={i === this.props.violations.length - 1 ? "item no-border" : "item"}>
                                            <label className="left-cell"><strong>{Utilities.formatDateObj(moment(violation.violationDate).toDate())}</strong></label>
                                            <label className="right-cell">{violation.incidentDescription}</label>
                                        </div>
                                    ))}
                                </div>
                            :
                                null
                        }
                    </div>

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Continue"
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverViolationsGroupIndex = !ownProps.match.params["driverViolationsGroupIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverViolationsGroupIndex"], 10);

    const drivers = state.externalQuote?.mvrResult.drivers.filter(x => !x.isExcluded && x.incidents?.some(i => (i.source & ViolationSource.VERISK) === ViolationSource.VERISK)) ?? null;
    const driver = drivers !== null ? drivers[driverViolationsGroupIndex] : null;
    const violations = driver?.incidents.filter(i => (i.source & ViolationSource.VERISK) === ViolationSource.VERISK) ?? null;

    return {
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        driverViolationsGroupIndex,
        driversViolationsGroupCount: drivers?.length ?? 0,
        driver: driver,
        violations: violations,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.FINALIZE)),
        reRateQuote: (quoteId: number, paymentPlanCode: number) => dispatch(fullQuoteActions.reRateQuote(quoteId, paymentPlanCode, true))
    };
};

export default connect(mapProps, mapDispatch)(Violations);
